import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../context/GlobalContext';
import AccessibleContent from '../../utils/AccessibleContent';

const LegalNotice = ({ store }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { currentLanguage } = useGlobalContext();

  const lang = currentLanguage?.code || 'en';

  const isMeaningfulHtml = (html) => {
    if (!html) return false;
    let text = html.replace(/<[^>]*>/g, '');
    text = text.replace(/&nbsp;/gi, ' ');
    text = text.replace(/\s+/g, ' ').trim();
    return text.length > 0;
  };

  const rawAccroche = store?.texteAccroche?.[lang] || '';
  const accrocheHtml = rawAccroche
    ? rawAccroche.replace('<p>', '<h2>').replace('</p>', '</h2>')
    : '';

  const showAccroche = isMeaningfulHtml(accrocheHtml);

  return (
    <div className="content">
      <div id="topSection">
        <div className={`overlayBox ${store.mainImageFilter ? 'overlay' : ''}`}>
          <div className="wrapper">

            {showAccroche && (
              <>
                <AccessibleContent
                  htmlContent={accrocheHtml}
                  className="headContent accrocheColor"
                />

                {!store.exception && (
                  <div className="showMoreBox">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate('/details');
                      }}
                      translate="true"
                    >
                      {t('En savoir plus')}
                    </a>
                  </div>
                )}
              </>
            )}

          </div>
        </div>
      </div>

      <div className="mainContent">
        <div className="wrapper mainWhiteBox">
          <div className="buttonAction">
            <a href="/home" className="buyCard returnToHome">
              {t('Acheter une e carte cadeau')}
            </a>
          </div>

          <div className="contentBody mainColor pt64">
            <div
              dangerouslySetInnerHTML={{ __html: store?.cgv?.[lang] || '' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalNotice;
